import { ICoordinate, IPlacePrediction, yupLocalized } from "@ryde/shared";

export interface IQuickStationFormModel {
  address: Partial<IPlacePrediction>;
  areaId: number;
  coordinate: ICoordinate;
}

export const rideAddQuickStationFormValidationRules = yupLocalized
  .object<IQuickStationFormModel>()
  .shape({
    areaId: yupLocalized.number().required(),
    coordinate: yupLocalized
      .object()
      .shape({
        lat: yupLocalized.number().required(),
        lng: yupLocalized.number().required(),
      })
      .required(),
    address: yupLocalized
      .object()
      .shape({
        placeId: yupLocalized.string().required(),
      })
      .required(),
  });

export enum QuickStationFormFields {
  address = "address",
  areaId = "areaId",
  coordinate = "coordinate",
}

export interface IRideAddQuickStationForm {
  className?: string;
  onClose: () => void;
  onSave: (data: {
    address: string;
    areaId: number;
    coordinate: { lat: number; lng: number };
  }) => void;
}
